import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaDateTimeDefinition } from './TypedDefinition'

export const SchemaDateTimePlugin = createSchemaPlugin(
  'Schema.DateTime',
  SchemaDateTimeDefinition
)
